import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const reviewAssessmentStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            padding: "20px 0px 0px 50px",
        },
        btn: {
            padding: "9px 28px 9px 28px",
            color: "white",
            backgroundColor: "#270ADC",
            marginTop: "10px",
            "&:hover": {
                backgroundColor: "#270ADC",
            },
        },
        text: {
            color: "rgba(0, 175, 65, 1)",
            display: "flex",
            marginTop: "10px",
        },
        selectContainer: {
            margin: "0px 0px 10px 0px",
        },
        smallIndicator: {
            height: "4vh",
            width: "10vh",
            display: "flex",
            alignItems: "center",
        },
        disabledBtn: {
            backgroundColor: "#AEA5E4",
            color: "#333333 !important",
        },
    })
);
